const layout = {
  'layout-header-profile-card-title': 'Настройки профиля',
  'layout-header-profile-card-view-profile': 'Просмотр профиля',
  'layout-header-profile-card-settings': 'Настройки аккаунта',
};

export default layout;
